import React from "react";
import "./DarkModeButton.css";
import { useTranslation } from "react-i18next";
import { useTldrawApp } from "./hooks/useTldrawApp";
import { MoonIcon } from "./icons/MoonIcon";
import { SunIcon } from "./icons/SunIcon";

export function DarkModeButton() {
  const [darkMode, setDarkMode] = React.useState<boolean>(false);
  const app = useTldrawApp();
  const { t } = useTranslation();

  const handleToggle = React.useCallback(() => {
    setDarkMode(!darkMode);
    app.setSetting("isDarkMode", !darkMode);
  }, [app, darkMode]);

  const buttonIcon = darkMode ? <SunIcon /> : <MoonIcon />;
  const darkClass = darkMode ? "is-dark" : "";

  return (
    <div className="btn-dark-mode">
      <button
        className={darkClass}
        onClick={handleToggle}
        title={darkMode ? t("BUTTON.LIGHT_MODE") : t("BUTTON.DARK_MODE")}
        aria-label={darkMode ? t("BUTTON.LIGHT_MODE") : t("BUTTON.DARK_MODE")}
      >
        {buttonIcon}
      </button>
    </div>
  );
}
